import {Model} from 'MWC';

const oneTimeCommission = 'one_time_commission',
    timeUnit = 'time_unit',
    realRate = ['real_rate'],
    months = 12,
    hundredPercent = 100,
    bankDays = 360;

export default class extends Model {
    static fields;

    constructor(data, type) {
        super();
        this.selectedType = type;
        this.creditSum = data.min;
        this.requiredPayment = 0;
        this.overpayment = 0;
        this.creditCost = 0;
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            ...data
        };
    }

    changeField(name, value) {
        this[name] = value;
        this.calculateIndicators();
    }

    getCreditSum() {
        return +this.creditSum;
    }

    getMinSumEdge() {
        return this.fields.min;
    }

    getMaxSumEdge() {
        return this.fields.max;
    }

    getSumStep() {
        return this.fields.step;
    }

    getCurrentLoanTerm() {
        return 0;
    }

    getCreditTerm() {
        return this.fields.terms[0];
    }

    getRate() {
        return this.fields.rate;
    }

    getDayRate() {
        const rate = this.getRate();
        return rate / bankDays;
    }

    getRealRate() {
        const term = this.getCurrentLoanTerm();
        return this.fields[realRate][term];
    }

    getOneTimeCommission() {
        return this.fields[oneTimeCommission];
    }

    getTimeUnit() {
        return this.fields[timeUnit];
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    setRequiredPayment(value) {
        this.requiredPayment = value;
    }

    getOverpayment() {
        return this.overpayment;
    }

    setOverpayment(value) {
        this.overpayment = value;
    }

    getCreditCost() {
        return this.creditCost;
    }

    setCreditCost(value) {
        this.creditCost = value;
    }

    calculateIndicators() {
        const creditSum = this.getCreditSum(),
            commission = this.getOneTimeCommission(),
            rate = this.getRate();

        const fullCreditSum =
            Math.round((creditSum + (creditSum * commission) / hundredPercent) * 100) / 100;
        const fullComission =
            Math.round(((fullCreditSum * rate) / months / hundredPercent) * 100) / 100;

        const sumToPay = fullCreditSum + fullComission;
        this.setRequiredPayment(sumToPay);

        const overpayment = sumToPay - creditSum;
        this.setOverpayment(overpayment);

        const creditCost = creditSum + overpayment;
        this.setCreditCost(creditCost);
    }
}
